import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { PageHeader, Section } from "../components/common";
import Timeline from "../components/Timeline";

export default function ActivityLog() {
  const { t } = useLang();
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/activity").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const shown = (list || []).filter((a) => `${a.user_name} ${a.action}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <PageHeader title={t("Activity Log", "Historial de actividad")} subtitle={t("Who did what, and when.", "Quién hizo qué y cuándo.")} />
      <input className="inp mb-4" placeholder={t("Filter…", "Filtrar…")} value={q} onChange={(e) => setQ(e.target.value)} data-testid="activity-filter-input" />
      <Section testid="activity-list"><Timeline items={shown} kind="activity" /></Section>
    </>
  );
}
